var legacyViewport = 'fx_b6b0f3e6_2datsy0';

export { legacyViewport };
//# sourceMappingURL=legacyScrollArea.vanilla.mjs.map
